import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  readTime: string;
  author: string;
  categoryName?: string;
}

export default function ArticleCard({
  id,
  title,
  excerpt,
  image,
  date,
  readTime,
  author,
  categoryName,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-[16/9] overflow-hidden bg-background-100">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4 md:p-5">
        {categoryName && (
          <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-medium px-2.5 py-1 rounded-full mb-2 whitespace-nowrap">
            {categoryName}
          </span>
        )}
        <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {excerpt}
        </p>
        <div className="flex items-center gap-3 text-xs text-foreground-400 flex-wrap">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {readTime}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {author}
          </span>
        </div>
      </div>
    </Link>
  );
}